import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove, updateOrder } = crudActions({ name: 'resources' })
